// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-oasis -> weidner-apartment-homes-oasis-oasis -> dobson-towne-centre
// Generated: 2026-10-27T17:09:28.564Z
// Counts: 2 design, 25 content, 23 slot group, 0 collection binding, 9 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#282624",
    "mappedField": null
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "VALUE",
    "value": "#3A312A",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about Dobson Towne Centre Apartments in Chandler, AZ? Our leasing team is here to help. Reach out for availability details, schedule a tour, or learn more about the community. We look forward to connecting with you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h1><strong>Faq</strong></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Dobson Towne Centre Apartment Homes in Chandler, AZ. Located in north Chandler near Chandler Mall, Fry's, and the Price Corridor, this community places you close to everyday essentials and local destinations. Enjoy modern apartment homes with features designed for comfort, along with community amenities that support your daily routine. Your controlled-access community near Loop 101, US 60, and I-10 makes getting around the greater Phoenix area simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.form_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>We'd love to hear from you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "tourblock.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dobson Towne Centre Apartments in Chandler, AZ, offers a range of amenities designed to support your daily routine. From community spaces that help you stay active and connected to in-home features that add comfort, everything is thoughtfully designed with you in mind. Enjoy convenient access to shared spaces and apartment interiors that are both functional and luxurious.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dobson Towne Centre Apartments offers 1, 2, and 3-bedroom floor plans designed for everyday living. Each home features an oversized patio and a full-size in-unit washer and dryer, providing added convenience. Whether you are working from home or relaxing, these layouts offer functional spaces that suit your routine. Explore available options online or schedule a tour to see them in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from 1, 2, or 3-bedroom apartments in Chandler, designed for your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-widget-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 13.5pt;\"><strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.&nbsp;</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at Dobson Towne Centre Apartments in Chandler, AZ, through our photo gallery. View apartment interiors, community amenities, and shared spaces to get a sense of what your daily life can look like here. From bright living areas to inviting outdoor spaces, the gallery highlights what you can expect when you call this community home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeamenities.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from one, two, and three-bedroom apartment homes designed to fit any lifestyle. Each layout offers a comfortable living space with thoughtful details throughout.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeneighborhood.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy access to a 24-hour fitness center, business center, two outdoor pools, and two spas. Inside your home, features such as tall ceilings, large windows, and faux wood flooring create a bright, welcoming space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dobson Towne Centre Apartments is located in north Chandler, AZ, near everyday conveniences and local destinations. You will find shopping and dining nearby at Chandler Mall and easy grocery access at Fry's. The community is also close to the Price Corridor, placing you near key areas within the city. With convenient access to Loop 101, US 60, and I-10, commuting and getting around Chander or the greater Phoenix area is simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule your tour of Dobson Towne Centre Apartments in Chandler, AZ. Explore 1, 2, and 3-bedroom homes featuring GE appliances and assigned covered parking. During your visit, you can also view the community clubhouse and two outdoor pools. Choose a virtual tour or schedule an in-person visit at a time that works for you. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour at Dobson Towne Centre in Chandler</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a closer look at Dobson Towne Centre Apartments in Chandler, AZ, with a virtual tour you can take from anywhere. Explore apartment layouts and experience the community's feel at your own pace. For a more personalized experience, connect with our leasing team to schedule a live virtual tour or plan an in-person visit. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "propertyoverview.front_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "contactblock.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/user/WeidnerApartments"
      }
    }
  },
  "amenities-hero.collage_image_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "amenities-hero.collage_image_2": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "contactblock.hero_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "floor-plans-hero.collage_image_1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "floor-plans-hero.collage_image_2": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_1": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_2": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "homeamenities.card3_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "neighborhood-hero.collage_image_1": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "neighborhood-hero.collage_image_2": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "pet-policy-hero.collage_image_1": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "pet-policy-hero.collage_image_2": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "resident-access-hero.collage_image_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "resident-access-hero.collage_image_2": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "tourblock.hero_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "virtual-tour-hero.collage_image_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "virtual-tour-hero.collage_image_2": {
    "sourceIndex": 23,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
